import axios from "axios";

import { getCustomToken } from "../helpers/utils";

const http = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,

  headers: {
    "content-type": "application/json",
    Authorization: `Bearer ${getCustomToken()}`,
  },
});

class RedeemService {
  getProfileHistory(user_id, currPage, pageSize, searchText) {
    let url = `/users/${user_id}/history`;

    url += "?page=" + currPage;
    url += "&size=" + pageSize;

    if (searchText && searchText.length > 0) {
      console.log("search: ", searchText);

      const specialCharsRegex = /^[A-Za-z\s&']+$/;

      if (!specialCharsRegex.test(searchText)) {
        // Special characters found, handle the notification or any other action
        throw new Error(
          "Invalid characters in search term. Please use alphabets, spaces, '&', and ''' only."
        );
      }

      url += "&search=" + searchText;
    }

    return http.get(url, {
      headers: {
        Authorization: `Bearer ${getCustomToken()}`,
      },
    });
  }

  getRate() {
    return http.get(`/core/convertion/config`, {
      headers: {
        Authorization: `Bearer ${getCustomToken()}`,
      },
    });
  }

  getPoints(user_id) {
    return http.get(`/users/${user_id}/points`, {
      headers: {
        Authorization: `Bearer ${getCustomToken()}`,
      },
    });
  }

  availGC(price, sku, quantity, title) {
    let payload = JSON.stringify({
      price: price,
      sku: sku,
      quantity: quantity,
      title: title,
    });

    return http.post(`/redeem`, payload, {
      headers: {
        Authorization: `Bearer ${getCustomToken()}`,
      },
    });
  }

  getAmazonProducts(currPage, pageSize, searchText) {
    let url = `/redeem/products/amazon`;

    url += "?page=" + currPage;
    url += "&size=" + pageSize;

    if (searchText && searchText.length > 0) {
      console.log("search: ", searchText);

      const specialCharsRegex = /^[A-Za-z\s&']+$/;

      if (!specialCharsRegex.test(searchText)) {
        // Special characters found, handle the notification or any other action
        throw new Error(
          "Invalid characters in search term. Please use alphabets, spaces, '&', and ''' only."
        );
      }

      url += "&search=" + searchText;
    }

    return http.get(url, {
      headers: {
        Authorization: `Bearer ${getCustomToken()}`,
      },
    });
  }

  getRewardsByGID(groupId, pageCount) {
    // Construct the base URL
    let url = "/reward";

    // Add "group_id" to the URL if it is provided and not null/undefined
    if (groupId !== null && groupId !== undefined) {
      url += `?group_id=${groupId}&`;
    }

    url += `page=${pageCount}&size=3`;

    // console.warn("URL maker:", url);

    return http.get(url, {
      headers: {
        Authorization: `Bearer ${getCustomToken()}`,
      },
    });
  }
}

export default new RedeemService();
